import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `` : `var(--color-${color})`;
};
const SvgDownloadIcon = ({ title, theme = null, titleId = "", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    xmlSpace="preserve"
    width="1em"
    height="1em"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g className="download_svg__nc-icon-wrapper">
      <path d="m62.906 37.587.003-.003L52.82 16.173A1.998 1.998 0 0 0 51 15h-9v4h7.712l8.637 18H42v7a2 2 0 0 1-2 2H24a2 2 0 0 1-2-2v-7H5.652l8.637-18H22v-4h-9c-.784 0-1.496.458-1.82 1.173L1.091 37.584l.003.003A.988.988 0 0 0 1 38v19a3 3 0 0 0 3 3h56a3 3 0 0 0 3-3V38a.988.988 0 0 0-.094-.413z" />
      <path
        data-color="color-2"
        d="M31.226 35.633a1 1 0 0 0 1.548 0l9-11A1 1 0 0 0 41 23h-8V4a1 1 0 1 0-2 0v19h-8a1 1 0 0 0-.774 1.633l9 11z"
      />
    </g>
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgDownloadStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgDownloadIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const DownloadIcon: any = SvgDownloadStyle;
export default DownloadIcon;
